import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import * as UserService from "../../services/UserService";
import backImg from "../../assets/img/icon_back.svg";
import analyticsLogEvent from "../../services/FirebaseService";
import {FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import Spinner from "../../components/Spinner";
import {useNavigate} from "react-router";

function ProfileChangePassword() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        currentPassword:"",
        newPassword:"",
        confirmNewPassword:"",
        isSubmitBtnEnabled: true,
        updatedAccountPopupStyle:hidden,
    });




    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.PROFILE_CHANGE_PASSWORD,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.PROFILE_CHANGE_PASSWORD
        });
    }, []);


    const goBack = () => {
        navigateTo(-1)
    }


    const handleOnChange = (e, input) => {
        if (input === "currentPassword") {
            setState({
                ...state,
                currentPassword: e.target.value
            })
        } else if (input === "newPassword") {
            setState({
                ...state,
                newPassword: e.target.value
            })
        } else if (input === "confirmNewPassword") {
            setState({
                ...state,
                confirmNewPassword: e.target.value
            })
        }
    }

    const validateInputs = () => {
        if (state.currentPassword === null ||
            state.currentPassword === "" ||
            state.newPassword === null ||
            state.newPassword === "" ||
            state.confirmNewPassword === null ||
            state.confirmNewPassword === "" ||
            state.newPassword !== state.confirmNewPassword) {
            return <FormattedMessage id="PleaseEnterAvalidPassword"/>
        } else {
            return null;
        }
    }

    const updateAccount = async () => {
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })

        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }

        if (!state.isSubmitBtnEnabled || state.loading) {
            return;
        }

        const body = {
            "email":StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "password": state.currentPassword,
            "newPassword": state.newPassword,
        }

        const response = await UserService.updateUserInformationWithoutHeaders(body);
        if (response.ok) {
            setState({
                ...state,
                updatedAccountPopupStyle: visible,
                loading: false,
                isSubmitBtnEnabled:false,
                currentPassword:"",
                newPassword:"",
                confirmNewPassword:"",
                errorMsg:null,
            })

            setTimeout(function () {
                setState({
                    ...state,
                    updatedAccountPopupStyle: hidden,
                    isSubmitBtnEnabled:true,
                    currentPassword:"",
                    newPassword:"",
                    confirmNewPassword:"",
                    errorMsg:null,
                })
            }, 2000);
        } else {
            if (response.data.code === 403) {
                setState({
                    ...state,
                    errorMsg: response.data.error,
                    loading: false,

                })
            }else{
                setState({
                    ...state,
                    errorMsg:  <FormattedMessage id="Error.genericError"/>,
                    loading: false,
                })
            }
        }
    }


    return (
        <div className="page-content without-actionsbar">
            <div className={state.updatedAccountPopupStyle+" modal-overlay always-invisible"} >   </div>
            <div className="modal confirmation-modal" data-qa="change-password-success-modal">
                <div className="row">
                    <p className="modal-text"><FormattedMessage id="YourPersonalDataHasBeenUpdated"/></p>
                </div>
            </div>


            <div className="login-container change-password">
                <a className="btn-back" onClick={goBack} data-qa="change-password-back-btn"><img alt="back button" src={backImg}/></a>

                <div className="login-container-content text-left">
                    <div className="login-container-content-top-text">
                        <FormattedMessage id="ChangePassword"/>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <label>{<FormattedMessage id="CurrentPassword"/>}</label>
                            <FormattedMessage id="CurrentPassword" defaultMessage="CurrentPassword">
                                {placeholder =>
                                    <input
                                        className="input"
                                        autoFocus={true}
                                        type="password"
                                        value={state.currentPassword}
                                        onChange={e => handleOnChange(e, "currentPassword")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="currentPwd"
                                        data-qa="change-password-current-pwd-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="NewPassword"/>}</label>
                            <FormattedMessage id="NewPassword" defaultMessage="NewPassword">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="password"
                                        value={state.newPassword}
                                        onChange={e => handleOnChange(e, "newPassword")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="newPwd"
                                        data-qa="change-password-new-pwd-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>

                        <div className="row">
                            <label>{<FormattedMessage id="ConfirmNewPassword"/>}</label>
                            <FormattedMessage id="ConfirmNewPassword" defaultMessage="ConfirmNewPassword">
                                {placeholder =>
                                    <input
                                        className="input no-border-radius"
                                        type="password"
                                        value={state.confirmNewPassword}
                                        onChange={e => handleOnChange(e, "confirmNewPassword")}
                                        maxLength={80}
                                        // placeholder={placeholder}
                                        autoComplete="off"
                                        id="confirmNewPwd"
                                        data-qa="change-password-confirm-new-pwd-input"
                                    />
                                }
                            </FormattedMessage>
                        </div>
                    </div>


                    <div className="row">
                        <button onClick={() => updateAccount()}
                                className={state.isSubmitBtnEnabled ?
                                    "btn btn-md btn-default uppercase update-btn"
                                    : "btn btn-md btn-default uppercase update-btn btn-disabled"}
                                data-qa="change-password-submit-btn">
                            <FormattedMessage id="Change" defaultMessage="Change"/>
                        </button>
                    </div>

                </div>

                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }

                {state.errorMsg != null ?
                    <div className="error-div" data-qa="change-password-error-div">
                        <p>&#9888;&nbsp;{state.errorMsg}</p>
                    </div>
                    : null
                }
            </div>
        </div>

    );
}

export default ProfileChangePassword;
